import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_WATCH_LIST_ENTRIES_COUNT } from "../types";

import {
  getWatchListEntriesCountPending,
  getWatchListEntriesCountFulfilled,
  getWatchListEntriesCountRejected,
} from "../actions";
import { sendApiRequest, notifyWarning, notifyError } from "../../../actions";
import { WATCH_LIST_ENTRY_MESSAGES } from "../constants/watchListEntryMessages";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "get",
  url: "watchlistentry/count",
  onSuccess: [
    (response) =>
      response.data === 0
        ? notifyWarning(WATCH_LIST_ENTRY_MESSAGES.NOT_FOUND)
        : getWatchListEntriesCountFulfilled(response),
  ],
  onError: [
    getWatchListEntriesCountRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getWatchListEntriesCountEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_WATCH_LIST_ENTRIES_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getWatchListEntriesCountPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getWatchListEntriesCountEpic$;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/getWatchListEntriesCountEpic.js